import { HTMLData_Source, Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1";
const htmlConverter = {
  toPm: {
    types: [Node_Type.HTML],
    // @ts-ignore $TSFixMe
    convert: (node) => {
      return {
        type: Node_Type.HTML,
        attrs: {
          ...node.htmlData,
          id: node.id,
          autoHeight: node.htmlData.autoHeight ?? true
        }
      };
    }
  },
  fromPm: {
    types: [Node_Type.HTML],
    convert: (node) => {
      const { id, ...data } = node.attrs || {};
      return {
        type: Node_Type.HTML,
        id,
        nodes: [],
        htmlData: {
          ...data,
          source: node.attrs?.source || HTMLData_Source.HTML,
          autoHeight: node.attrs?.autoHeight === false ? false : void 0,
          iframeHeight: void 0
        }
      };
    }
  }
};
export {
  htmlConverter
};
//# sourceMappingURL=html-converter.js.map
